export default __webpack_public_path__ + "static/media/womenInTech.ef9a76c7.jpg";